import React, { useContext } from "react";
import { Text, ResourceList, InlineStack, BlockStack } from "@shopify/polaris";

import constant from "lib/constant/constant";

// import context
import { PrivateContext } from "lib/context";
import { AdvanceShippingContext } from "app/shipping/modules/provider/features/subFeatures/advance/context/context";

// import component
import { baseHelper } from "lib/helpers";
import Actions from "./action";

// import propType
import { ruleItemProp } from "./props";

const RuleItem = (props) => {
  const { isVendorAllowed } = useContext(AdvanceShippingContext);
  const { currentUser = {}, cms } = useContext(PrivateContext);
  const { moneyFormat, item = {}, band = [], destinations = [], products = [], editModal, deleteModal } = props || {};
  const {
    id,
    shippingBandId,
    price,
    description,
    condition,
    destinationCode,
    productId,
    priceType,
    isShippingDisabled,
    createdAt,
    updatedAt,
  } = item;
  const isDestination = condition === constant.DESTINATION;
  const isProduct = condition === constant.PRODUCT;

  if (item.condition === null) return null;
  const shippingBand =
    (band.length > 0 && band.find((key) => key.value === shippingBandId || key.parentId === shippingBandId)) || false;

  const { options: countries = [] } =
    destinations.find(
      (destination) => destination && destination.options.find((option) => option.value === destinationCode)
    ) || {};
  const destination = countries.find((country) => country.value === destinationCode);
  const product = products.find((pItem) => pItem.value === productId);
  const isFreeOption = priceType === constant.FREE;
  const priceTypeText = isFreeOption ? cms("label.free") : cms("label.fixed");

  const { _id: currentUserId = null } = currentUser || {};
  const { userId: ruleCreatedBy = null } = item || {};
  const shortcutActions = [
    {
      content: cms("button.edit"),
      onAction: () => editModal(item),
      disabled: !isVendorAllowed,
    },
    {
      content: cms("button.delete"),
      destructive: true,
      onAction: () => deleteModal(item),
      disabled: !isVendorAllowed || ruleCreatedBy !== currentUserId,
    },
  ];

  return (
    <ResourceList.Item id={id} accessibilityLabel={`${cms("label.viewDetails")} `}>
      <div className="custom-wrapper">
        <InlineStack blockAlign="start" align="space-between">
          <BlockStack>
            <BlockStack>
              <Text as="span" fontWeight="semibold">
                {(shippingBand && shippingBand.label) || ""}
              </Text>
              <Text variant="bodySm" as="p">
                {description}
              </Text>
            </BlockStack>
            <br />
            <BlockStack>
              {isDestination && (
                <Text variant="bodySm" as="p">
                  {`${cms("label.destination")}: ${(destination && destination.label) || ""}`}
                </Text>
              )}
              {isProduct && product && (
                <Text variant="bodySm" as="p">{`${cms("label.product")}: ${(product && product.label) || ""}`}</Text>
              )}
              <Text variant="bodySm" as="p">{`${cms("label.priceType")}: ${priceTypeText}`}</Text>
              <Text variant="bodySm" as="p">{`${cms("label.cost")}: ${moneyFormat} ${isFreeOption ? "0" : price}`}</Text>
              <Text variant="bodySm" as="p">
                {`${cms("label.shipping")}: ${isShippingDisabled ? cms("label.disabled") : cms("label.enabled")}`}
              </Text>
              {createdAt && (
                <Text variant="bodySm" as="p">
                  {`Created At: ${baseHelper.formatDate(createdAt)}`}
                </Text>
              )}
              {updatedAt && (
                <Text variant="bodySm" as="p">
                  {`Last updated At: ${baseHelper.formatDate(updatedAt)}`}
                </Text>
              )}
            </BlockStack>
          </BlockStack>
          <Actions actions={shortcutActions} />
        </InlineStack>
      </div>
    </ResourceList.Item>
  );
};
RuleItem.propTypes = ruleItemProp.type;
export default RuleItem;
